import http from '@/services/http';
import apiEndpoints from '@/services/apiEndpoints';

const actions = {
  async getListFaq (_, payload) {
    const response = await http.get(apiEndpoints.getListFaq, payload);
    if (response.status && response.data) return response.data;
    return [];
  },
};
export default {
  actions,
};
